// Vendor imports
import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import intersect from '@alpinejs/intersect'
import breakpoint from 'alpinejs-breakpoints'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'

Alpine.plugin(intersect)
Alpine.plugin(breakpoint)
Alpine.plugin(collapse)
Alpine.plugin(focus)
window.Alpine = Alpine
window.tippy = tippy
window.AlpineBreakpointPluginBreakpointsList = [
	'xs',
	'sm',
	'md',
	'lg',
	'xl',
	'2xl',
	'3xl',
	'max',
	'wide',
]
window.Alpine.start()

import 'lazysizes/plugins/respimg/ls.respimg'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import 'lazysizes'
import 'lazysizes/plugins/object-fit/ls.object-fit'

// Module imports
import './modules/carousel'
import './modules/filters'
import './modules/gsap'
import './modules/lazy-video'
import './modules/membershipCalculator'
import './modules/rive'
import './modules/svgIconSprite'
import './modules/video-fit'

document.addEventListener('DOMContentLoaded', () => {
	setTimeout(() => {
		window.dispatchEvent(new Event('resize'));
	}, 100);

	// Initialize section title visibility
	// initSectionTitleVisibility();

	// Initialize lightbox functionality
	initSummaryLightbox();
});

function initSummaryLightbox() {
	const lightbox = document.getElementById('summary-lightbox');
	const closeBtn = document.getElementById('close-lightbox');
	const readMoreBtns = document.querySelectorAll('.read-more-btn');

	if (!lightbox || !closeBtn) return;

	// Open lightbox when read more is clicked
	readMoreBtns.forEach(btn => {
		btn.addEventListener('click', (e) => {
			e.preventDefault();
			const fullSummary = btn.getAttribute('data-full-summary');
			const personName = btn.getAttribute('data-person-name');

			document.getElementById('lightbox-person-name').textContent = personName;
			document.getElementById('lightbox-summary').textContent = fullSummary;

			lightbox.classList.remove('hidden');
			lightbox.classList.add('flex');
			document.body.style.overflow = 'hidden';

			// Trigger transition after a small delay to ensure display is set
			setTimeout(() => {
				lightbox.classList.remove('opacity-0');
				lightbox.querySelector('.transform').classList.remove('scale-95');
				lightbox.querySelector('.transform').classList.add('scale-100');
			}, 10);
		});
	});

	// Close lightbox when close button is clicked
	closeBtn.addEventListener('click', () => {
		closeLightbox();
	});

	// Close lightbox when clicking outside the modal
	lightbox.addEventListener('click', (e) => {
		if (e.target === lightbox) {
			closeLightbox();
		}
	});

	// Close lightbox with Escape key
	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && !lightbox.classList.contains('hidden')) {
			closeLightbox();
		}
	});

	function closeLightbox() {
		// Start transition out
		lightbox.classList.add('opacity-0');
		lightbox.querySelector('.transform').classList.remove('scale-100');
		lightbox.querySelector('.transform').classList.add('scale-95');

		// Hide after transition completes
		setTimeout(() => {
			lightbox.classList.add('hidden');
			lightbox.classList.remove('flex');
			document.body.style.overflow = '';
		}, 300);
	}
}


